import {Cookie} from "../utility/cookie";

export const jobSearch = () => {
    const reload = (success, query) => {
        if (typeof query === 'undefined') {
            query = '';
            (new FormData(document.getElementById('job-search'))).forEach(function (v, k) {
                query += '&'+[k,v].join('=');
            });
        }

        fetch(`/about/search-careers/?${query}`).then(function (response) {
            if (response.ok) {
                return response.text();
            }
            return Promise.reject(response);
        }).then(function (data) {
            let doc = document.implementation.createHTMLDocument("");
            doc.open().write(data);
            doc.close();
            document.getElementById('search-results').innerHTML = doc.getElementById('search-results').innerHTML;

            let lang = Cookie.get('_kbs_lang') || 'en';
            document.getElementById('search-results').querySelectorAll(`.lang.${lang}`).forEach(item => item.classList.add('show'));
        }).then(function () {
            if (typeof success === 'function') {
                success();
            }
        }).catch(function (error) {
            console.warn(error);
        });
    }

    window.addEventListener('load', () => {
        if (!document.querySelector('.exploreCareers .modal')) {
            return;
        }

        document.getElementById('job-search').addEventListener('reset', (e) => {
            reload(null, '');
        });

        if (Cookie.get('_kbs_jobs_modal')) {
            return;
        }

        Cookie.set('_kbs_jobs_modal', 1);

        document.querySelector('.exploreCareers').setAttribute('x-data', '{ open: true }');

        document.querySelector('.exploreCareers .modal .actions button').addEventListener('click', () => {
            const lang = document.getElementById('pre-lang').value;
            const state = document.getElementById('pre-state').value;

            document.querySelector(`#lang-toggle a[data-lang="${lang}"]`).dispatchEvent(new Event('click'));
            document.getElementById('job-state').value = state;

            reload(() => {
                document.querySelector('.exploreCareers').setAttribute('x-data', '{ open: false }');
            });
        });
    });
}
